import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaX } from "react-icons/fa6";
import Navbar from "../components/Navbar";
import "./RegistroEnviado.css";


const UsuarioRechazado = () => {

    const [cambioSituacion, setCambioSituacion] = useState(false);
    const [terminosAceptados, setTerminosAceptados] = useState(false);

    // Para manejar mensajes de error
    const [errorMessage, setErrorMessage] = useState("");

    // HOOK para redirigir
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrorMessage(""); // reiniciamos cualquier mensaje previo

        // 1. Comprobamos que se acepte el cambio de situacion
        if (!cambioSituacion) {
            setErrorMessage("Debes declarar que tu situación ha cambiado.");
            return;
        }

        // 2. Comprobamos que se aceptan los términos
        if (!terminosAceptados) {
            setErrorMessage("Debes aceptar los Términos y Condiciones de uso.");
            return;
        }

        // 3. Formulario válido: enviamos datos (a tu servicio/bbdd) y redirigimos
        navigate("/registro-enviado"); // Redirección a la página de confirmación
    };

    return (
        <>
        <Navbar />

        <main className="formulario-registro rechazo fixed flex-center">

            <div className="formulario column fondo-blanco relative">
                {/* Botón cerrar X */}
                <Link to="/" className="cerrar rojo absolute"><FaX/></Link>
                
                <div className="situacion column gap-25">
                    <p className="rojo">El <span className="bold">20/05/2025</span> intentaste registrarte y tu solicitud fue rechazada por<br></br><span className="bold">motivo del rechazo de la solicitud de registro.</span></p>
                    <div className="align-center gap-5 rojo">
                        <input
                            type="checkbox"
                            id="terminos"
                            checked={cambioSituacion}
                            onChange={() => setCambioSituacion(!cambioSituacion)}
                        />
                        <label htmlFor="terminos">Mi situación ha cambiado y quiero registrarme</label>
                    </div>
                </div>

                {/* terminos/condiciones + botón registro */}
                <div className="terminos-enviar between">

                    {/* terminos/condiciones */}
                    <div className="campo terminos align-center">
                        <input
                            type="checkbox"
                            id="terminos"
                            checked={terminosAceptados}
                            onChange={() => setTerminosAceptados(!terminosAceptados)}
                        />
                        <label htmlFor="terminos"> He leído y acepto los <Link to="/">Términos y Condiciones de uso</Link></label>
                    </div>

                    {/* mensajes error + botón registro */}
                    <div className="error-boton-container">
                        {errorMessage && <p className="error-message error-registro">{errorMessage}</p>}
                        <button type="submit" className="fondo-blanco verde"  onClick={handleSubmit}>Registrarme</button>
                    </div>
                </div>
            </div>
            
        </main>
        </>
    );
};

export default UsuarioRechazado;